// Independent Variables (input-only)
export const OD_Free = 0;
export const Wire_Dia = 1;
export const Coils_T = 2;
export const M_1 = 3;
export const M_2 = 4;
export const Coil_Spacing = 5;

// Dependent Variables (input-output)
export const Mean_Dia = 0;
export const ID_Free = 1;
export const Coils_A = 2;
export const Rate = 3;
export const Deflect_1 = 4;
export const Deflect_2 = 5;
export const L_Body = 6;
export const L_1 = 7;
export const L_2 = 8;
export const End_Angle_Free = 9;
export const Stroke = 10;
export const Weight = 11;
export const Spring_Index = 12;
export const End_Deflect_All = 13;
export const Stress_1 = 14;
export const Stress_2 = 15;
export const Stress_End = 16;
export const FS_2 = 17;
export const FS_CycleLife = 18;
export const Cycle_Life = 19;
export const PC_Safe_Deflect = 20;
export const Force_Arm_2 = 21;
export const Energy = 22;
export const Spring_Type = 23;
export const Prop_Calc_Method = 24;
export const Material_Type = 25;
export const ASTM_Fed_Spec = 26;
export const Process = 27;
export const Heat_Treat = 28;
export const Catalog_Number = 29;
export const Material_File = 30;
export const Life_Category = 31;
export const Inactive_Coils = 32;
export const Density = 33;
export const Elastic_Modulus = 34;
export const Hot_Factor_Kh = 35;
export const Tensile = 36;
export const PC_Ten_Bnd_Endur = 37;
export const PC_Ten_Bnd_Stat = 38;
export const Stress_Lim_Bnd_Endur = 39;
export const Stress_Lim_Bnd_Stat = 40;
export const End_Type = 41;
export const Arm_1 = 42;
export const Arm_2 = 43;
export const Xlen_1 = 44;
export const Xlen_2 = 45;
export const L_End_1 = 46;
export const L_End_2 = 47;
export const tbase010 = 48;
export const tbase400 = 49;
export const const_term = 50;
export const slope_term = 51;
export const tensile_010 = 52;